/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   CurrentSearchView constants
 */

export const BEGIN_SHIMMER = '@@nzr/CurrentSearchView/BEGIN_SHIMMER'
export const FINISH_SHIMMER = '@@nzr/CurrentSearchView/FINISH_SHIMMER'

export const SHOW_MARKERS = '@@nzr/CurrentSearchView/SHOW_MARKERS'
export const HIDE_MARKERS = '@@nzr/CurrentSearchView/HIDE_MARKERS'

export const SET_SHOW_NIGHTLY_PRICE = '@@nzr/CurrentSearchView/SET_SHOW_NIGHTLY_PRICE'
export const SET_FREEZE_BOX = '@@nzr/CurrentSearchView/SET_FREEZE_BOX'
export const SET_SAVED_SEARCH_EMAIL = '@@nzr/CurrentSearchView/SET_SAVED_SEARCH_EMAIL'

export const SET_SELECTED_POI_CATEGORY = '@@nzr/CurrentSearchView/SET_SELECTED_POI_CATEGORY'

export const SET_TOAST_TYPE = '@@nzr/CurrentSearchView/SET_TOAST_TYPE'
export const CLEAR_TOAST_TYPE = '@@nzr/CurrentSearchView/CLEAR_TOAST_TYPE'

export const SET_TOGGLE_VALUE = '@@nzr/CurrentSearchView/SET_TOGGLE_VALUE'
export const RESET_TOGGLE_VALUE = '@@nzr/CurrentSearchView/RESET_TOGGLE_VALUE'
